import React, { useEffect, useState } from 'react';
import { useLocation, useNavigate, useSearchParams } from 'react-router-dom';
import logo from './../assets/images/logo.png';
import './../styles/DefaultPage.css';
import Button, { BUTTON_TYPES } from '../components/Button';
import Page from '../components/Page';
import { checkSession, login } from '../api/login/UserLogin';



const DefaultPage = () => {

  // check session when loaded
  // since on the home page, we don't need to redirect to another page, except the dashboard after login
  // put redirectURL to null
  console.log("default page");
  const [searchParams] = useSearchParams();
  const [target, setTarget] = useState(null);
  const navigate = useNavigate();
  const location = useLocation();

  useEffect(() => { 
    setTarget(searchParams.get("target"));
    checkSession(location.pathname, navigate);
  }, [searchParams, location, navigate]);


  return (
    <Page>
      <div className="default-container">
        <img src={logo} alt="Logo" className="default-logo" />
        <h1 className="default-title">Active Membership Tracker</h1>
          <Button
            id="login-button"
            type={BUTTON_TYPES.primary}
            buttonText="Login"
            className="default-button"
            action={() => {login(target);}}
          />
      </div>
    </Page>
  );
};

export default DefaultPage;
